module.exports = __webpack_public_path__ + "img/领先的区块链模式物联⽹和边缘计算能⼒.41a6064b.png";